// This function allow to reference all chunks
__webpack_require__.hu = (chunkId) => {
	// return url for filenames based on template
	return "7a34953-" + chunkId + "-wps-hmr.js";
};